import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { BookingForm } from './booking-form';
import { useBookingForm } from '../../hooks/use-booking-form';

export function BookingModal({
    isOpen,
    onClose,
    propertyId,
}: {
    isOpen: boolean;
    onClose: () => void;
    propertyId: number;
}) {
    const { handleClose, confirmBookingMutation } = useBookingForm({
        propertyId, overrideBookableServices: null, isOpen, onClose,
    });

    return (
        <Modal
            isOpen={isOpen}
            autoFocus={false}
            closeOnEsc={!confirmBookingMutation.isPending}
            closeOnOverlayClick={!confirmBookingMutation.isPending}
            onClose={handleClose}
            size="2xl"
        >
            <ModalOverlay />
            <ModalContent>
                <BookingForm
                    propertyId={propertyId}
                    onClose={onClose}
                    overrideBookableServices={null}
                />
            </ModalContent>
        </Modal>
    );
}
